<template>
  <div class="hg_nav_containner">
    <img
      src="https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/logo.png"
      alt=""
      class="img_logo"
    />
  </div>
</template>

<script>
export default {
  name: "notFound",
  components: {},
  data: () => ({}),
  mounted() {},
  methods: {
   
  },
};
</script>

<style>
.hg_nav_containner {
  width: 100%;
  height: 100px;
  background: #ffffff;

  display: flex;
  justify-content: center;
  align-items: center;
}
.hg_nav_containner .img_logo {
  width: 233px;
  height: 44px;
}
</style>
